import { render, staticRenderFns } from "./Antenna.vue?vue&type=template&id=5cb6bd4e&scoped=true&"
import script from "./Antenna.vue?vue&type=script&lang=js&"
export * from "./Antenna.vue?vue&type=script&lang=js&"
import style0 from "./Antenna.vue?vue&type=style&index=0&id=5cb6bd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6bd4e",
  null
  
)

export default component.exports